module.exports = __webpack_public_path__ + "img/1523171577.65d353f4.jpg";